export const source = {
	REQUEST: 'SOURCE_REQUEST',
	RECEIVE: 'SOURCE_RECEIVE',
	REQUEST_CH: 'SOURCE_CH_REQUEST',
	RECEIVE_CH: 'SOURCE_CH_RECEIVE',
	REQUEST_SOURCE_DATE:'REQUEST_SOURCE_DATE_LIST',
	RECEIVE_SOURCE_DATE: 'RECEIVE_SOURCE_DATE_LIST',
	REQUEST_MEDIA_SENTIMENT_VIBE: 'REQUEST_MEDIA_SENTIMENT_VIBE',
	RECEIVE_MEDIA_SENTIMENT_VIBE: 'RECEIVE_MEDIA_SENTIMENT_VIBE',
};



// WEBPACK FOOTER //
// ./src/constants/widgetSource.constants.js